import React from 'react';
import { IconButton, Tooltip } from '@axiom/ui';

import type { MatchingCandidate } from '../../api/chat-api';

export type ChatCandidatesButtonProps = {
  idx: number;
  // Non-empty by construction: `ChatTextarea` renders this only when there is something to restore.
  matchingCandidates: MatchingCandidate[];
  /*
    Must stay referentially stable - it is `useCallback`ed in `Spark` so that passing it down
    does not defeat `ChatTurn`'s memo, which is what keeps a keystroke from re-rendering the
    whole transcript.
  */
  showCandidates: (candidates: MatchingCandidate[]) => void;
};

/**
 * The grid holds one set of talent at a time and a conversation produces several, so each answer
 * carries its own way of putting its people back.
 *
 * **Clicking must open the drawer as well as fill the grid.** With the drawer shut, filling it
 * shows nothing but the drawer button turning green, which reads as a click that failed.
 */
export const ChatCandidatesButton = ({
  idx,
  matchingCandidates,
  showCandidates,
}: ChatCandidatesButtonProps) => {
  return (
    <Tooltip
      fade
      hideClose
      name={`SHOW_CANDIDATES_TOOLTIP_${idx}`}
      position="top"
      variation="minimal"
      anchor={
        <IconButton
          icon="candidate"
          name={`SHOW_CANDIDATES_${idx}`}
          onClick={() => {
            showCandidates(matchingCandidates);
          }}
          pattern="secondary"
          size="small"
          variation="minimal"
        />
      }
    >
      {`Show the ${matchingCandidates.length} lawyer${
        matchingCandidates.length === 1 ? '' : 's'
      } from this answer in the grid`}
    </Tooltip>
  );
};
